import { api } from './index.js';

export const adminGetProjects = async ({
	offset = 0,
	limit = 100,
	search = '',
	archived = false,
	dateRange,
	demo = false,
}) => {
	const params = {
		deleted: archived,
		search,
		offset,
		limit,
		demo,
	};

	if (dateRange?.from) params.start_date = dateRange.from;
	if (dateRange?.to) params.end_date = dateRange.to;

	const { data } = await api.get('/admin/projects', { params });
	return data;
};

export const getProjectResourceReport = async uuid => {
	try {
		const res = await api.get(`/admin/resource_report/${uuid}`);
		return res;
	} catch (err) {
		console.log(err);
		return err.response;
	}
};

export const adminGetProjectFilesDowloadUrl = async (
	project_uuid,
	path = 'images/',
	fileName = null
) => {
	let params = {
		path,
	};

	if (fileName) {
		params.file_name = fileName;
	}

	const { data } = await api.get(
		`/admin/get_project_files_urls/${project_uuid}`,
		{
			params,
		}
	);
	return data;
};

export const adminGetProjectJsonFile = async (
	project_uuid,
	path = 'log.json'
) => {
	let params = {
		path,
	};

	const { data } = await api.get(`/admin/project_json/${project_uuid}`, {
		params,
	});
	return data;
};

export const adminGetSagmakerFiles = async project_uuid => {
	const { data } = await api.get(
		`/admin/project_sagemaker_file_urls/${project_uuid}`
	);
	return data;
};

export const setDemoProject = async fields => {
	const { projectId: project_uuid, demoModel: demo_model_uuid } = fields;
	const { data } = await api.post(`/admin/demo_project`, {
		project_uuid,
		demo_model_uuid,
	});
	return data;
};

export const unsetDemoProject = async project_uuid => {
	const { data } = await api.post(
		`/admin/unset_demo_project/${project_uuid}`
	);
	return data;
};

// TODO: This should be a post operation, not get, - km
export const copyProject = async ({ projectId, email }) => {
	const { data } = await api.get(
		`projects/make_project_available_for_user/${projectId}?email=${email}`
	);
	return data;
};

export const adminUpdateProject = async ({
	uuid,
	title,
	wms_publish,
	owner_email,
	organization_uuid,
}) => {
	const params = {
		uuid,
		title,
		wms_publish,
		owner_email,
		org_uuid: organization_uuid,
	};

	console.info('adminUpdateProject: ', params);
	const { data } = await api.post(`/admin/project/${uuid}/update`, params);
	return data;
};

// Not working correctly
// export const adminGetProjectImagesDowloadZip = async project_uuid => {
// 	const res = await api.get(
// 		`/admin/project_images_download_zip/${project_uuid}`,
// 		{
// 			headers: {
// 				'Content-Type': 'application/zip',
// 			},
// 		}
// 	);
// 	return res;
// };
